// Shared helpers + small primitives used across Vehicle Command Center tabs.
// Kept intentionally small: these are the "lego pieces" that every tab file
// imports. No JSX with heavy state goes here.
import { CalendarDays } from "lucide-react";
import { BLOCKING_BOOKING_STATUSES } from "@/lib/status.jsx";

export const MAX_PHOTO_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_PHOTOS_PER_VEHICLE = 30;

export const BOOKING_GROUPS = [
  { id: "active",    label: "Active & upcoming", statuses: BLOCKING_BOOKING_STATUSES },
  { id: "completed", label: "Completed",         statuses: new Set(["completed"]) },
  { id: "cancelled", label: "Cancelled / no-show", statuses: new Set(["cancelled", "no_show"]) },
];

export function canEditVehicle(user) {
  const role = user?.account_type || user?.role;
  if (role === "business_owner" || role === "platform_admin") return true;
  return (user?.permissions || []).includes("vehicles");
}

// Tiny presentational tiles reused by Overview + Finance tabs.
export function Info({ label, value }) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</div>
      <div className="mt-0.5">{value}</div>
    </div>
  );
}

export function KpiTile({ label, value, tone = "emerald" }) {
  const toneCls = tone === "rose"
    ? "border-rose-200 bg-rose-50 text-rose-900"
    : "border-emerald-200 bg-emerald-50 text-emerald-900";
  return (
    <div className={`rounded-xl border ${toneCls} p-4`}>
      <div className="text-[10px] uppercase tracking-[0.18em] font-semibold">{label}</div>
      <div className="mt-1 font-display text-2xl font-bold font-mono">{value}</div>
    </div>
  );
}

// CalendarDays re-export so consumers don't have to import lucide twice.
export { CalendarDays };
